import "../stylesheets/game.scss";
import "../channels/index.js";
import ahoy from "ahoy.js";
import "rollbar";
import "bootstrap";

if (
  window.location.pathname.includes("/play") ||
  window.location.hostname.includes("play.socialcipher.com")
) {
  ahoy.configure({ cookies: false });
  window.ahoy = ahoy;

  window.ICE_SERVERS = JSON.parse(
    document.querySelector("meta[name='ice-servers']").getAttribute("content")
  );
  const dataUrl = document
    .querySelector("meta[name='data-url']")
    .getAttribute("content");
  const frameworkUrl = document
    .querySelector("meta[name='framework-url']")
    .getAttribute("content");
  const codeUrl = document
    .querySelector("meta[name='code-url']")
    .getAttribute("content");

  window.onbeforeunload = function () {
    return "";
  };

  const handleError = (message) => {
    document.querySelector("#error-message").classList.remove("d-none");
    throw message;
  };

  window.getStudentCode = function () {
    return window.GLOBAL_STUDENT_CODE || "0";
  };

  window.fullScreen = function () {
    if (window.unity) {
      window.unity.SetFullscreen(true);
    }
  };

  function startUnity() {
    console.log("startUnity");
    var startTime = new Date().getTime();
    ahoy.track("Started Download", { start_time: startTime });
    var progress_bar = document.querySelector(".progress-bar");
    document.querySelector(".load-container").style.display = "";

    const unityContainer = document.querySelector("#unity-canvas");
    const config = {
      companyName: "SocialCipher",
      productName: "Ava",
      productVersion: "6.0.0",
      // dataUrl: "#{cloud_front_file_url(@game.data)}",
      dataUrl: dataUrl,
      // frameworkUrl: "#{cloud_front_file_url(@game.framework)}",
      frameworkUrl: frameworkUrl,
      // codeUrl: "#{cloud_front_file_url(@game.code)}"
      codeUrl: codeUrl,
    };
    setTimeout(() => {
      createUnityInstance(unityContainer, config, (progress) => {
        var pct = (progress * 100) | 0;
        progress_bar.style.width = pct + "%";
        progress_bar.textContent = pct + "%";
      })
        .then((unityInstance) => {
          window.unity = unityInstance;
          document.querySelector(".load-container").style.display = "none";
          var endTime = new Date().getTime();
          ahoy.track("Completed Download", {
            recorded_local_duration: endTime - startTime,
            end_time: endTime,
          });
        })
        .catch(handleError);
    }, 1000);
  }

  document.addEventListener("DOMContentLoaded", () => {
    try {
      // fullscreen button
      document
        .querySelector(".fullscreen")
        .addEventListener("click", fullScreen);
      // Student play links can supply a play code directly.
      const params = new URLSearchParams(window.location.search);
      window.GLOBAL_STUDENT_CODE = params.get("sso")
        ? params.get("student_code")
        : null;
      startUnity();
    } catch (error) {
      console.error(error);
      startUnity();
    }
  });
}
